import React, { useState } from "react";
import { notification, Button, Descriptions, Table } from "antd";
import { FilePdfOutlined } from "@ant-design/icons";
import dayjs from "dayjs";
import axios from "axios";
import { BACKEND_URL, FILES_URL } from "../../../config/config";
import { currencyFormatter } from "../../../helpers/currencyHelper";
import { useAuth } from "../../../hooks";

export function ContractApprove({ contract, setIsVisibleModal, handleRefreshChange }) {
  const [loading, setLoading] = useState(false);
  const { user } = useAuth();

  const fmtDate = (d) => (d ? dayjs(d).format("MM/DD/YYYY") : "-");
  const fmtAmount = (n) => currencyFormatter(Number(n ?? 0));

  const siteRows = (contract?.relatedSites || []).map((site, idx) => ({
    key: site?.account?._id || idx,
    site: site?.account?.accountName || "-",
    plan: site?.selectedPARC?.name || "-",
    planOption: site?.selectedPlanOption?.optionName || "-",
  }));

  const siteColumns = [
    { title: "Site", dataIndex: "site", key: "site" },
    { title: "Plan", dataIndex: "plan", key: "plan" },
    { title: "Plan Option", dataIndex: "planOption", key: "planOption" },
  ];

  const cancelModal = () => {
    setIsVisibleModal(false);
  };

  const approveContract = async () => {
    if (loading) {
      return;
    }
    setLoading(true);

    const url = `${BACKEND_URL}/customers/approveParc360Contract`;
    const data = {
      historyId: contract._id,
      contact_id: user._id,
    };

    const response = await axios.post(url, data).catch((err) => {
      setLoading(false);
      notification["error"]({
        message:
          err?.response?.data?.message || "Could not approve this contract.",
      });
    });

    if (response?.data?.status === 1) {
      notification["success"]({
        message: "Contract approved. Your PARC 360 plan has been applied to all sites.",
      });
      handleRefreshChange();
      setIsVisibleModal(false);
      setLoading(false);
    }
  };

  return (
    <>
      <span>
        You are about to approve PARC 360 contract for{" "}
        <b>{contract?.account?.accountName}</b>. Please review the summary
        below before approving.
      </span>

      <Descriptions
        column={2}
        bordered
        size="small"
        style={{ marginTop: "1rem" }}
      >
        <Descriptions.Item label="Portfolio Account">
          {contract?.account?.accountName || "-"}
        </Descriptions.Item>
        <Descriptions.Item label="Total Amount">
          {fmtAmount(contract?.totalAmount)}
        </Descriptions.Item>
        <Descriptions.Item label="Effective Date">
          {fmtDate(contract?.effectiveDate)}
        </Descriptions.Item>
        <Descriptions.Item label="Expiration Date">
          {fmtDate(contract?.expirationDate)}
        </Descriptions.Item>
      </Descriptions>

      <Table
        style={{ marginTop: "1rem" }}
        columns={siteColumns}
        dataSource={siteRows}
        pagination={false}
        size="small"
      />

      {contract?.documentPath && (
        <div style={{ marginTop: "1rem" }}>
          <Button
            type="default"
            icon={<FilePdfOutlined />}
            href={`${FILES_URL}/${contract.documentPath}`}
            target="_blank"
            rel="noreferrer"
            block
          >
            View Full Contract Document
          </Button>
        </div>
      )}

      <div
        style={{
          width: "100%",
          display: "flex",
          justifyContent: "space-around",
          paddingTop: "1.5rem",
        }}
      >
        <Button onClick={cancelModal} disabled={loading}>
          Cancel
        </Button>
        <Button
          onClick={approveContract}
          type="primary"
          loading={loading}
          disabled={loading}
        >
          Approve Contract
        </Button>
      </div>
    </>
  );
}
